module.exports = __webpack_public_path__ + "static/fonts/iconfont.fe5e3436.ttf";